import { useState, useEffect } from "react";
import { RadarChart, Radar, PolarGrid, PolarAngleAxis, ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip } from "recharts";

// ─── MOCK DATA ────────────────────────────────────────────────────────────────

const OPERATORS = [
  {
    id: 1,
    name: "Bet360 Liberia",
    type: "Sports Betting",
    license: "NLA-SB-2021-004",
    licenseExpiry: "2026-03-15",
    kybStatus: "VERIFIED",
    kybDate: "2025-11-02",
    ownershipVerified: true,
    beneficialOwners: 2,
    jurisdiction: "Liberia",
    amlRisk: 18,
    riskTrend: "stable",
    flags: [],
    lastReview: "2025-12-18",
    nextReview: "2026-03-18",
    transactionVolume: "LRD 12.4M",
    complianceScore: 94,
    monitoringStatus: "ROUTINE",
    kybDocs: ["Articles of Incorporation", "Director IDs", "Bank Reference", "Tax Clearance"],
    amlHistory: [
      { month: "Jul", score: 15 }, { month: "Aug", score: 18 }, { month: "Sep", score: 16 },
      { month: "Oct", score: 20 }, { month: "Nov", score: 17 }, { month: "Dec", score: 18 },
    ],
    radarData: [
      { axis: "Ownership", value: 95 }, { axis: "Financials", value: 90 }, { axis: "Reporting", value: 98 },
      { axis: "AML Policy", value: 88 }, { axis: "Payments", value: 92 },
    ],
  },
  {
    id: 2,
    name: "Lucky Star Casino",
    type: "Online Casino",
    license: "NLA-OC-2020-001",
    licenseExpiry: "2025-12-31",
    kybStatus: "REVIEW_REQUIRED",
    kybDate: "2024-08-14",
    ownershipVerified: false,
    beneficialOwners: 4,
    jurisdiction: "Liberia / BVI",
    amlRisk: 74,
    riskTrend: "increasing",
    flags: ["Revenue drop 45%", "Unverified beneficial owner", "License near expiry"],
    lastReview: "2024-08-14",
    nextReview: "2026-01-10",
    transactionVolume: "LRD 6.1M",
    complianceScore: 41,
    monitoringStatus: "ELEVATED",
    kybDocs: ["Articles of Incorporation", "Director IDs"],
    amlHistory: [
      { month: "Jul", score: 45 }, { month: "Aug", score: 50 }, { month: "Sep", score: 55 },
      { month: "Oct", score: 62 }, { month: "Nov", score: 68 }, { month: "Dec", score: 74 },
    ],
    radarData: [
      { axis: "Ownership", value: 40 }, { axis: "Financials", value: 55 }, { axis: "Reporting", value: 48 },
      { axis: "AML Policy", value: 60 }, { axis: "Payments", value: 35 },
    ],
  },
  {
    id: 3,
    name: "Galaxy Gaming",
    type: "Online Casino",
    license: "NLA-OC-2019-002",
    licenseExpiry: "2024-11-30",
    kybStatus: "SUSPENDED",
    kybDate: "2023-05-20",
    ownershipVerified: false,
    beneficialOwners: 6,
    jurisdiction: "Liberia / Malta / BVI",
    amlRisk: 96,
    riskTrend: "critical",
    flags: ["License expired", "Suspicious ownership chain", "Revenue concealment pattern", "LIPAY processor abuse"],
    lastReview: "2023-05-20",
    nextReview: "N/A – Suspended",
    transactionVolume: "LRD 0 (Suspended)",
    complianceScore: 8,
    monitoringStatus: "SUSPENDED",
    kybDocs: ["Articles of Incorporation"],
    amlHistory: [
      { month: "Jul", score: 72 }, { month: "Aug", score: 78 }, { month: "Sep", score: 84 },
      { month: "Oct", score: 89 }, { month: "Nov", score: 93 }, { month: "Dec", score: 96 },
    ],
    radarData: [
      { axis: "Ownership", value: 10 }, { axis: "Financials", value: 15 }, { axis: "Reporting", value: 8 },
      { axis: "AML Policy", value: 20 }, { axis: "Payments", value: 5 },
    ],
  },
  {
    id: 4,
    name: "Premier Lotto",
    type: "National Lottery",
    license: "NLA-LT-2018-001",
    licenseExpiry: "2027-06-30",
    kybStatus: "VERIFIED",
    kybDate: "2025-09-10",
    ownershipVerified: true,
    beneficialOwners: 1,
    jurisdiction: "Liberia",
    amlRisk: 32,
    riskTrend: "improving",
    flags: ["Round-number reporting pattern"],
    lastReview: "2025-09-10",
    nextReview: "2026-03-10",
    transactionVolume: "LRD 18.2M",
    complianceScore: 76,
    monitoringStatus: "WATCH",
    kybDocs: ["Articles of Incorporation", "Director IDs", "Bank Reference", "Tax Clearance", "Audited Accounts"],
    amlHistory: [
      { month: "Jul", score: 45 }, { month: "Aug", score: 40 }, { month: "Sep", score: 38 },
      { month: "Oct", score: 35 }, { month: "Nov", score: 34 }, { month: "Dec", score: 32 },
    ],
    radarData: [
      { axis: "Ownership", value: 90 }, { axis: "Financials", value: 75 }, { axis: "Reporting", value: 65 },
      { axis: "AML Policy", value: 80 }, { axis: "Payments", value: 70 },
    ],
  },
  {
    id: 5,
    name: "Monrovia Bet",
    type: "Sports Betting",
    license: "NLA-SB-2022-007",
    licenseExpiry: "2027-01-15",
    kybStatus: "VERIFIED",
    kybDate: "2025-10-22",
    ownershipVerified: true,
    beneficialOwners: 3,
    jurisdiction: "Liberia",
    amlRisk: 27,
    riskTrend: "stable",
    flags: [],
    lastReview: "2025-10-22",
    nextReview: "2026-04-22",
    transactionVolume: "LRD 9.7M",
    complianceScore: 88,
    monitoringStatus: "ROUTINE",
    kybDocs: ["Articles of Incorporation", "Director IDs", "Bank Reference", "Tax Clearance"],
    amlHistory: [
      { month: "Jul", score: 30 }, { month: "Aug", score: 28 }, { month: "Sep", score: 29 },
      { month: "Oct", score: 27 }, { month: "Nov", score: 26 }, { month: "Dec", score: 27 },
    ],
    radarData: [
      { axis: "Ownership", value: 88 }, { axis: "Financials", value: 85 }, { axis: "Reporting", value: 90 },
      { axis: "AML Policy", value: 82 }, { axis: "Payments", value: 86 },
    ],
  },
  {
    id: 6,
    name: "DoxxBet Liberia",
    type: "Online Casino / Sports Betting",
    license: "NLA-HY-2023-010",
    licenseExpiry: "2026-08-01",
    kybStatus: "PENDING",
    kybDate: "2025-07-01",
    ownershipVerified: false,
    beneficialOwners: 5,
    jurisdiction: "Liberia / Slovakia",
    amlRisk: 55,
    riskTrend: "increasing",
    flags: ["Incomplete beneficial ownership docs", "Cross-border payment concerns"],
    lastReview: "2025-07-01",
    nextReview: "2026-01-20",
    transactionVolume: "LRD 4.3M",
    complianceScore: 58,
    monitoringStatus: "WATCH",
    kybDocs: ["Articles of Incorporation", "Director IDs", "Bank Reference"],
    amlHistory: [
      { month: "Jul", score: 40 }, { month: "Aug", score: 44 }, { month: "Sep", score: 48 },
      { month: "Oct", score: 50 }, { month: "Nov", score: 52 }, { month: "Dec", score: 55 },
    ],
    radarData: [
      { axis: "Ownership", value: 45 }, { axis: "Financials", value: 65 }, { axis: "Reporting", value: 60 },
      { axis: "AML Policy", value: 55 }, { axis: "Payments", value: 50 },
    ],
  },
];

const AUDIT_TIMELINE = [
  { date: "Dec 28, 2025", operator: "Galaxy Gaming", event: "License suspension enforcement recorded", type: "critical", icon: "🔴" },
  { date: "Dec 22, 2025", operator: "Lucky Star Casino", event: "Beneficial ownership re-verification triggered — 3rd owner unconfirmed", type: "warning", icon: "🟡" },
  { date: "Dec 18, 2025", operator: "Bet360 Liberia", event: "Annual compliance review completed — PASSED", type: "success", icon: "✅" },
  { date: "Dec 15, 2025", operator: "Lucky Star Casino", event: "AML risk threshold breached (score: 74) — escalated to FIA", type: "critical", icon: "🔴" },
  { date: "Dec 12, 2025", operator: "Premier Lotto", event: "Round-number reporting pattern flagged for investigation", type: "warning", icon: "🟡" },
  { date: "Nov 30, 2025", operator: "DoxxBet Liberia", event: "Cross-border payment route to Slovakia flagged for review", type: "warning", icon: "🟡" },
  { date: "Nov 10, 2025", operator: "Monrovia Bet", event: "Ownership structure re-verified — 3 beneficial owners confirmed", type: "success", icon: "✅" },
  { date: "Oct 22, 2025", operator: "Monrovia Bet", event: "Scheduled KYB review — documentation complete", type: "success", icon: "✅" },
  { date: "Sep 10, 2025", operator: "Premier Lotto", event: "Annual KYB renewal completed — all documents verified", type: "success", icon: "✅" },
  { date: "Jul 01, 2025", operator: "DoxxBet Liberia", event: "New operator onboarded — KYB verification initiated", type: "info", icon: "🔵" },
];

// ─── HELPERS ──────────────────────────────────────────────────────────────────

const riskColor = (score) => {
  if (score >= 70) return { text: "#FF4D4F", bg: "rgba(255,77,79,0.12)", label: "HIGH RISK" };
  if (score >= 40) return { text: "#FAAD14", bg: "rgba(250,173,20,0.12)", label: "MEDIUM RISK" };
  return { text: "#52C41A", bg: "rgba(82,196,26,0.12)", label: "LOW RISK" };
};

const kybColors = {
  VERIFIED: { text: "#52C41A", bg: "rgba(82,196,26,0.15)", border: "rgba(82,196,26,0.4)" },
  REVIEW_REQUIRED: { text: "#FAAD14", bg: "rgba(250,173,20,0.15)", border: "rgba(250,173,20,0.4)" },
  PENDING: { text: "#40A9FF", bg: "rgba(64,169,255,0.15)", border: "rgba(64,169,255,0.4)" },
  SUSPENDED: { text: "#FF4D4F", bg: "rgba(255,77,79,0.15)", border: "rgba(255,77,79,0.4)" },
};

const monitoringColors = {
  ROUTINE: "#52C41A",
  WATCH: "#FAAD14",
  ELEVATED: "#FF7A00",
  SUSPENDED: "#FF4D4F",
};

const trendIcons = {
  stable: "→",
  improving: "↓",
  increasing: "↑",
  critical: "⚠",
};

const trendColors = {
  stable: "#8C8C8C",
  improving: "#52C41A",
  increasing: "#FAAD14",
  critical: "#FF4D4F",
};

// ─── ANIMATED SCORE RING ──────────────────────────────────────────────────────

function ScoreRing({ score, size = 72 }) {
  const [displayed, setDisplayed] = useState(0);
  const c = riskColor(100 - score); // invert: high score = low risk
  const radius = (size - 12) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (score / 100) * circumference;

  useEffect(() => {
    let start = 0;
    const step = () => {
      start += 2;
      setDisplayed(Math.min(start, score));
      if (start < score) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [score]);

  const ringColor = score >= 70 ? "#52C41A" : score >= 40 ? "#FAAD14" : "#FF4D4F";

  return (
    <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
      <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth={8} />
      <circle
        cx={size / 2} cy={size / 2} r={radius} fill="none"
        stroke={ringColor} strokeWidth={8}
        strokeDasharray={circumference}
        strokeDashoffset={circumference - (displayed / 100) * circumference}
        strokeLinecap="round"
        style={{ transition: "stroke-dashoffset 0.05s linear" }}
      />
      <text
        x={size / 2} y={size / 2 + 5} textAnchor="middle"
        fill="white" fontSize={16} fontWeight={700}
        style={{ transform: `rotate(90deg)`, transformOrigin: `${size / 2}px ${size / 2}px`, fontFamily: "'IBM Plex Mono', monospace" }}
      >
        {displayed}
      </text>
    </svg>
  );
}

// ─── PULSE DOT ────────────────────────────────────────────────────────────────

function PulseDot({ color }) {
  return (
    <span style={{ position: "relative", display: "inline-block", width: 10, height: 10, marginRight: 6 }}>
      <span style={{
        position: "absolute", inset: 0, borderRadius: "50%", background: color, opacity: 0.4,
        animation: "pulse-ring 2s ease-out infinite",
      }} />
      <span style={{ position: "absolute", inset: 2, borderRadius: "50%", background: color }} />
      <style>{`@keyframes pulse-ring { 0% { transform:scale(1); opacity:0.4; } 100% { transform:scale(2.5); opacity:0; } }`}</style>
    </span>
  );
}

// ─── OPERATOR CARD ────────────────────────────────────────────────────────────

function OperatorCard({ op, selected, onClick }) {
  const kyb = kybColors[op.kybStatus];
  const risk = riskColor(op.amlRisk);
  const isSelected = selected?.id === op.id;

  return (
    <div onClick={onClick} style={{
      background: isSelected ? "rgba(64,169,255,0.08)" : "rgba(255,255,255,0.03)",
      border: isSelected ? "1px solid rgba(64,169,255,0.5)" : "1px solid rgba(255,255,255,0.07)",
      borderRadius: 10, padding: "14px 16px", cursor: "pointer",
      transition: "all 0.2s ease",
      boxShadow: isSelected ? "0 0 0 1px rgba(64,169,255,0.3), inset 0 0 20px rgba(64,169,255,0.04)" : "none",
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
        <div>
          <div style={{ fontFamily: "'IBM Plex Sans', sans-serif", fontWeight: 600, fontSize: 13, color: "#E8E8E8", marginBottom: 3 }}>
            {op.name}
          </div>
          <div style={{ fontSize: 11, color: "#8C8C8C", fontFamily: "'IBM Plex Mono', monospace" }}>{op.type}</div>
        </div>
        <ScoreRing score={op.complianceScore} size={56} />
      </div>
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 8 }}>
        <span style={{
          fontSize: 10, fontWeight: 700, letterSpacing: "0.06em", fontFamily: "'IBM Plex Mono', monospace",
          color: kyb.text, background: kyb.bg, border: `1px solid ${kyb.border}`,
          padding: "2px 8px", borderRadius: 4,
        }}>{op.kybStatus.replace("_", " ")}</span>
        <span style={{
          fontSize: 10, fontWeight: 700, letterSpacing: "0.06em", fontFamily: "'IBM Plex Mono', monospace",
          color: risk.text, background: risk.bg, border: `1px solid ${risk.text}30`,
          padding: "2px 8px", borderRadius: 4,
        }}>AML {op.amlRisk}</span>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        <PulseDot color={monitoringColors[op.monitoringStatus]} />
        <span style={{ fontSize: 10, color: monitoringColors[op.monitoringStatus], fontFamily: "'IBM Plex Mono', monospace", fontWeight: 600 }}>
          {op.monitoringStatus}
        </span>
        {op.flags.length > 0 && (
          <span style={{ marginLeft: "auto", fontSize: 10, color: "#FF7A00", background: "rgba(255,122,0,0.1)", padding: "1px 7px", borderRadius: 3 }}>
            {op.flags.length} FLAG{op.flags.length > 1 ? "S" : ""}
          </span>
        )}
      </div>
    </div>
  );
}

// ─── DETAIL PANEL ─────────────────────────────────────────────────────────────

function DetailPanel({ op }) {
  const [tab, setTab] = useState("kyb");
  const kyb = kybColors[op.kybStatus];
  const risk = riskColor(op.amlRisk);
  const REQUIRED_DOCS = ["Articles of Incorporation", "Director IDs", "Bank Reference", "Tax Clearance", "Audited Accounts"];

  return (
    <div style={{
      background: "rgba(255,255,255,0.025)", border: "1px solid rgba(255,255,255,0.08)",
      borderRadius: 12, padding: 24, height: "100%",
    }}>
      {/* Header */}
      <div style={{ marginBottom: 20 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
          <h3 style={{ fontFamily: "'IBM Plex Sans', sans-serif", fontWeight: 700, fontSize: 18, color: "#F0F0F0", margin: 0 }}>
            {op.name}
          </h3>
          <span style={{
            fontSize: 11, fontWeight: 700, fontFamily: "'IBM Plex Mono', monospace",
            color: kyb.text, background: kyb.bg, border: `1px solid ${kyb.border}`,
            padding: "4px 12px", borderRadius: 20,
          }}>{op.kybStatus.replace("_", " ")}</span>
        </div>
        <div style={{ fontSize: 12, color: "#595959", fontFamily: "'IBM Plex Mono', monospace" }}>
          {op.license} · {op.jurisdiction}
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: "flex", gap: 2, marginBottom: 20, borderBottom: "1px solid rgba(255,255,255,0.07)", paddingBottom: 0 }}>
        {["kyb", "aml", "radar"].map(t => (
          <button key={t} onClick={() => setTab(t)} style={{
            background: "none", border: "none", cursor: "pointer",
            padding: "8px 16px", fontSize: 11, fontWeight: 600, letterSpacing: "0.08em",
            fontFamily: "'IBM Plex Mono', monospace", textTransform: "uppercase",
            color: tab === t ? "#40A9FF" : "#595959",
            borderBottom: tab === t ? "2px solid #40A9FF" : "2px solid transparent",
            marginBottom: -1, transition: "all 0.2s",
          }}>
            {t === "kyb" ? "KYB Verification" : t === "aml" ? "AML Monitor" : "Risk Radar"}
          </button>
        ))}
      </div>

      {/* KYB Tab */}
      {tab === "kyb" && (
        <div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 20 }}>
            {[
              { label: "Beneficial Owners", value: op.beneficialOwners },
              { label: "Ownership Verified", value: op.ownershipVerified ? "✓ Yes" : "✗ No", color: op.ownershipVerified ? "#52C41A" : "#FF4D4F" },
              { label: "License Expiry", value: op.licenseExpiry },
              { label: "Last KYB Review", value: op.kybDate },
              { label: "Next Review Due", value: op.nextReview },
              { label: "Transaction Vol.", value: op.transactionVolume },
            ].map(item => (
              <div key={item.label} style={{ background: "rgba(255,255,255,0.03)", borderRadius: 8, padding: "10px 14px" }}>
                <div style={{ fontSize: 10, color: "#595959", marginBottom: 4, fontFamily: "'IBM Plex Mono', monospace", textTransform: "uppercase", letterSpacing: "0.06em" }}>{item.label}</div>
                <div style={{ fontSize: 13, fontWeight: 600, color: item.color || "#D9D9D9", fontFamily: "'IBM Plex Sans', sans-serif" }}>{item.value}</div>
              </div>
            ))}
          </div>

          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 11, color: "#595959", marginBottom: 10, fontFamily: "'IBM Plex Mono', monospace", textTransform: "uppercase", letterSpacing: "0.06em" }}>Document Checklist</div>
            {REQUIRED_DOCS.map(doc => {
              const have = op.kybDocs.includes(doc);
              return (
                <div key={doc} style={{ display: "flex", alignItems: "center", gap: 10, padding: "7px 0", borderBottom: "1px solid rgba(255,255,255,0.04)" }}>
                  <span style={{ fontSize: 14, color: have ? "#52C41A" : "#FF4D4F" }}>{have ? "✓" : "✗"}</span>
                  <span style={{ fontSize: 12, color: have ? "#A8A8A8" : "#595959", fontFamily: "'IBM Plex Sans', sans-serif" }}>{doc}</span>
                  {!have && <span style={{ marginLeft: "auto", fontSize: 10, color: "#FF7A00", background: "rgba(255,122,0,0.1)", padding: "1px 7px", borderRadius: 3 }}>REQUIRED</span>}
                </div>
              );
            })}
          </div>

          {op.flags.length > 0 && (
            <div style={{ background: "rgba(255,77,79,0.06)", border: "1px solid rgba(255,77,79,0.2)", borderRadius: 8, padding: "12px 14px" }}>
              <div style={{ fontSize: 10, color: "#FF4D4F", marginBottom: 8, fontFamily: "'IBM Plex Mono', monospace", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em" }}>⚠ Active Flags</div>
              {op.flags.map(f => (
                <div key={f} style={{ fontSize: 12, color: "#FF7A00", marginBottom: 5, display: "flex", alignItems: "flex-start", gap: 6 }}>
                  <span style={{ marginTop: 1 }}>›</span> {f}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* AML Tab */}
      {tab === "aml" && (
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 20, padding: "14px 18px", background: risk.bg, border: `1px solid ${risk.text}30`, borderRadius: 10 }}>
            <div>
              <div style={{ fontSize: 10, color: "#595959", fontFamily: "'IBM Plex Mono', monospace", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 4 }}>AML Risk Score</div>
              <div style={{ fontSize: 36, fontWeight: 800, color: risk.text, fontFamily: "'IBM Plex Mono', monospace", lineHeight: 1 }}>{op.amlRisk}<span style={{ fontSize: 16, color: "#595959" }}>/100</span></div>
              <div style={{ fontSize: 11, color: risk.text, marginTop: 4, fontWeight: 600 }}>{risk.label}</div>
            </div>
            <div style={{ marginLeft: "auto", textAlign: "right" }}>
              <div style={{ fontSize: 22, color: trendColors[op.riskTrend] }}>{trendIcons[op.riskTrend]}</div>
              <div style={{ fontSize: 10, color: trendColors[op.riskTrend], fontFamily: "'IBM Plex Mono', monospace", textTransform: "uppercase" }}>{op.riskTrend}</div>
            </div>
          </div>

          <div style={{ fontSize: 11, color: "#595959", marginBottom: 10, fontFamily: "'IBM Plex Mono', monospace", textTransform: "uppercase", letterSpacing: "0.06em" }}>6-Month AML Risk Trajectory</div>
          <ResponsiveContainer width="100%" height={140}>
            <AreaChart data={op.amlHistory} margin={{ top: 5, right: 5, left: -30, bottom: 0 }}>
              <defs>
                <linearGradient id="amlGrad" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor={risk.text} stopOpacity={0.3} />
                  <stop offset="95%" stopColor={risk.text} stopOpacity={0.02} />
                </linearGradient>
              </defs>
              <XAxis dataKey="month" tick={{ fontSize: 10, fill: "#595959", fontFamily: "'IBM Plex Mono', monospace" }} axisLine={false} tickLine={false} />
              <YAxis domain={[0, 100]} tick={{ fontSize: 10, fill: "#595959" }} axisLine={false} tickLine={false} />
              <Tooltip contentStyle={{ background: "#1A1A2E", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 6, fontSize: 11, fontFamily: "'IBM Plex Mono', monospace" }} labelStyle={{ color: "#8C8C8C" }} />
              <Area type="monotone" dataKey="score" stroke={risk.text} strokeWidth={2} fill="url(#amlGrad)" dot={{ r: 3, fill: risk.text }} />
            </AreaChart>
          </ResponsiveContainer>

          <div style={{ marginTop: 16, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            {[
              { label: "Monitoring Status", value: op.monitoringStatus, color: monitoringColors[op.monitoringStatus] },
              { label: "Compliance Score", value: `${op.complianceScore}/100` },
              { label: "Last Review", value: op.lastReview },
              { label: "Next Review", value: op.nextReview },
            ].map(item => (
              <div key={item.label} style={{ background: "rgba(255,255,255,0.03)", borderRadius: 8, padding: "10px 14px" }}>
                <div style={{ fontSize: 10, color: "#595959", marginBottom: 4, fontFamily: "'IBM Plex Mono', monospace", textTransform: "uppercase", letterSpacing: "0.06em" }}>{item.label}</div>
                <div style={{ fontSize: 13, fontWeight: 600, color: item.color || "#D9D9D9", fontFamily: "'IBM Plex Sans', sans-serif" }}>{item.value}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Radar Tab */}
      {tab === "radar" && (
        <div>
          <div style={{ fontSize: 11, color: "#595959", marginBottom: 16, fontFamily: "'IBM Plex Mono', monospace", textTransform: "uppercase", letterSpacing: "0.06em" }}>Compliance Dimension Analysis</div>
          <ResponsiveContainer width="100%" height={220}>
            <RadarChart data={op.radarData}>
              <PolarGrid stroke="rgba(255,255,255,0.08)" />
              <PolarAngleAxis dataKey="axis" tick={{ fontSize: 11, fill: "#8C8C8C", fontFamily: "'IBM Plex Mono', monospace" }} />
              <Radar name={op.name} dataKey="value" stroke="#40A9FF" fill="#40A9FF" fillOpacity={0.15} strokeWidth={2} dot={{ r: 3, fill: "#40A9FF" }} />
            </RadarChart>
          </ResponsiveContainer>

          <div style={{ marginTop: 8 }}>
            {op.radarData.map(d => (
              <div key={d.axis} style={{ display: "flex", alignItems: "center", gap: 10, padding: "6px 0", borderBottom: "1px solid rgba(255,255,255,0.04)" }}>
                <span style={{ fontSize: 11, color: "#8C8C8C", fontFamily: "'IBM Plex Sans', sans-serif", width: 100 }}>{d.axis}</span>
                <div style={{ flex: 1, height: 4, background: "rgba(255,255,255,0.06)", borderRadius: 2 }}>
                  <div style={{ width: `${d.value}%`, height: "100%", borderRadius: 2, background: d.value >= 70 ? "#52C41A" : d.value >= 40 ? "#FAAD14" : "#FF4D4F", transition: "width 1s ease" }} />
                </div>
                <span style={{ fontSize: 11, color: "#D9D9D9", fontFamily: "'IBM Plex Mono', monospace", width: 32, textAlign: "right" }}>{d.value}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// ─── TIMELINE ─────────────────────────────────────────────────────────────────

const timelineTypeColors = {
  critical: "#FF4D4F",
  warning: "#FAAD14",
  success: "#52C41A",
  info: "#40A9FF",
};

function AuditTimeline() {
  return (
    <div>
      <div style={{ fontSize: 11, color: "#595959", marginBottom: 16, fontFamily: "'IBM Plex Mono', monospace", textTransform: "uppercase", letterSpacing: "0.08em" }}>Compliance Audit Trail — Last 90 Days</div>
      <div style={{ position: "relative" }}>
        <div style={{ position: "absolute", left: 18, top: 0, bottom: 0, width: 1, background: "rgba(255,255,255,0.07)" }} />
        {AUDIT_TIMELINE.map((item, i) => (
          <div key={i} style={{ display: "flex", gap: 16, marginBottom: 18, position: "relative" }}>
            <div style={{
              width: 36, height: 36, borderRadius: "50%", flexShrink: 0,
              background: `${timelineTypeColors[item.type]}18`,
              border: `1px solid ${timelineTypeColors[item.type]}40`,
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 14, zIndex: 1,
            }}>{item.icon}</div>
            <div style={{ flex: 1, paddingTop: 6 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
                <span style={{ fontSize: 11, fontWeight: 700, color: "#D9D9D9", fontFamily: "'IBM Plex Sans', sans-serif" }}>{item.operator}</span>
                <span style={{ fontSize: 10, color: "#595959", fontFamily: "'IBM Plex Mono', monospace" }}>{item.date}</span>
              </div>
              <div style={{ fontSize: 12, color: "#8C8C8C", lineHeight: 1.5 }}>{item.event}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── SUMMARY BAR ──────────────────────────────────────────────────────────────

function SummaryBar() {
  const verified = OPERATORS.filter(o => o.kybStatus === "VERIFIED").length;
  const avgCompliance = Math.round(OPERATORS.reduce((s, o) => s + o.complianceScore, 0) / OPERATORS.length);
  const highRisk = OPERATORS.filter(o => o.amlRisk >= 70).length;
  const flags = OPERATORS.reduce((s, o) => s + o.flags.length, 0);

  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 12, marginBottom: 24 }}>
      {[
        { label: "KYB Verified", value: `${verified}/${OPERATORS.length}`, sub: "operators confirmed", color: "#52C41A", icon: "✓" },
        { label: "Avg. Compliance", value: `${avgCompliance}%`, sub: "portfolio score", color: avgCompliance >= 70 ? "#52C41A" : "#FAAD14", icon: "◎" },
        { label: "High Risk Operators", value: highRisk, sub: "AML score ≥ 70", color: highRisk > 0 ? "#FF4D4F" : "#52C41A", icon: "⚠" },
        { label: "Active Flags", value: flags, sub: "requiring review", color: flags > 0 ? "#FAAD14" : "#52C41A", icon: "⚑" },
      ].map(item => (
        <div key={item.label} style={{
          background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.07)",
          borderRadius: 10, padding: "14px 18px",
        }}>
          <div style={{ fontSize: 10, color: "#595959", marginBottom: 6, fontFamily: "'IBM Plex Mono', monospace", textTransform: "uppercase", letterSpacing: "0.07em" }}>{item.label}</div>
          <div style={{ display: "flex", alignItems: "baseline", gap: 6 }}>
            <span style={{ fontSize: 28, fontWeight: 800, color: item.color, fontFamily: "'IBM Plex Mono', monospace", lineHeight: 1 }}>{item.value}</span>
          </div>
          <div style={{ fontSize: 10, color: "#595959", marginTop: 4 }}>{item.sub}</div>
        </div>
      ))}
    </div>
  );
}

// ─── MAIN COMPONENT ───────────────────────────────────────────────────────────

export default function NLA_ComplianceIntelligence() {
  const [selected, setSelected] = useState(OPERATORS[1]); // default: Lucky Star (interesting flags)
  const [view, setView] = useState("operators"); // operators | timeline

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #0D0D1A 0%, #0A1628 50%, #0D0D1A 100%)",
      fontFamily: "'IBM Plex Sans', 'Segoe UI', sans-serif",
      color: "#D9D9D9",
      padding: 24,
    }}>
      {/* Google Fonts */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;600;700&family=IBM+Plex+Sans:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { width: 6px; } ::-webkit-scrollbar-track { background: transparent; } ::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.1); border-radius: 3px; }
      `}</style>

      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 24 }}>
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
            <div style={{ width: 6, height: 28, background: "linear-gradient(180deg, #40A9FF, #1890FF)", borderRadius: 3 }} />
            <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: "#F0F0F0", letterSpacing: "-0.02em" }}>
              Compliance Intelligence Engine
            </h1>
          </div>
          <div style={{ fontSize: 11, color: "#595959", marginLeft: 16, fontFamily: "'IBM Plex Mono', monospace" }}>
            NLA · Operator Verification & AML Monitoring · As of Dec 28, 2025
          </div>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          {["operators", "timeline"].map(v => (
            <button key={v} onClick={() => setView(v)} style={{
              background: view === v ? "rgba(64,169,255,0.15)" : "rgba(255,255,255,0.04)",
              border: `1px solid ${view === v ? "rgba(64,169,255,0.5)" : "rgba(255,255,255,0.08)"}`,
              color: view === v ? "#40A9FF" : "#8C8C8C", cursor: "pointer",
              padding: "7px 16px", borderRadius: 7, fontSize: 11, fontWeight: 600,
              fontFamily: "'IBM Plex Mono', monospace", textTransform: "uppercase", letterSpacing: "0.07em",
              transition: "all 0.2s",
            }}>
              {v === "operators" ? "⊞ Operators" : "≡ Audit Trail"}
            </button>
          ))}
        </div>
      </div>

      {/* Summary */}
      <SummaryBar />

      {/* Main Content */}
      {view === "operators" ? (
        <div style={{ display: "grid", gridTemplateColumns: "320px 1fr", gap: 16 }}>
          {/* Operator List */}
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <div style={{ fontSize: 10, color: "#595959", fontFamily: "'IBM Plex Mono', monospace", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 4 }}>
              Licensed Operators ({OPERATORS.length})
            </div>
            {OPERATORS.map(op => (
              <OperatorCard key={op.id} op={op} selected={selected} onClick={() => setSelected(op)} />
            ))}
          </div>

          {/* Detail Panel */}
          <div>
            {selected
              ? <DetailPanel op={selected} />
              : <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", color: "#595959", fontSize: 13 }}>← Select an operator to view details</div>
            }
          </div>
        </div>
      ) : (
        <div style={{
          background: "rgba(255,255,255,0.025)", border: "1px solid rgba(255,255,255,0.07)",
          borderRadius: 12, padding: 28,
        }}>
          <AuditTimeline />
        </div>
      )}

      {/* Footer */}
      <div style={{ marginTop: 20, textAlign: "center", fontSize: 10, color: "#333", fontFamily: "'IBM Plex Mono', monospace" }}>
        GCRMS · XI CONSULT CORP · CONFIDENTIAL — NLA DEMO BUILD
      </div>
    </div>
  );
}